<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
    <div fxFlex="100">


        <div>
          <mat-card class="content-card">

              <mat-card-content>
                <div class="w-100">
                  <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%;">

                    <!-- Left Column: Type (Email/SMS/Push) -->
                    <div *ngIf="newsletter">
                      <span style="font-size: 2em; font-weight: bold; margin: 0 15px 0 0;">
                        <ng-container *ngIf="newsletter.type == newsletterType.Email">E-Mail</ng-container>
                        <ng-container *ngIf="newsletter.type == newsletterType.Sms">SMS</ng-container>
                        <ng-container *ngIf="newsletter.type == newsletterType.Push">Push</ng-container>
                      </span>

                      <span class="recipients-badge" style="background-color: #b6d8ff; color: black; font-weight: bold; margin-right: 10px;" *ngIf="newsletter.isPrepared">
                        Recipients prepared
                      </span>

                      <span class="recipients-badge" style="background-color: #ffe5c9; color: black; font-weight: bold; margin-right: 10px;" *ngIf="!newsletter.isActive">
                        Pending approval
                      </span>

                      <span  class="recipients-badge" style="background-color: #95c0e3; color: white; font-weight: bold;  margin-right: 10px;" *ngIf="!(newsletter.isSending || newsletter.isSent) && newsletter.isActive">
                        Approved
                      </span>

                    </div>

                    <!-- Right Column: Controls -->
                    <div *ngIf="newsletter" style="display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 8px; text-align: right; max-width: 85%;">


                      <button mat-raised-button color="primary"
                              [disabled]="isSaving || newsletter == null || (newsletter?.isSending ?? false) || (newsletter?.isSent ?? false) || (newsletter?.isPreparing ?? false) || isPreparing"
                              (click)="save()">Save</button>

                      <button *ngIf="!(newsletter.isSending || newsletter.isSent) && !newsletter.isActive"
                              [class.spinner]="isPreparing || newsletter?.isPreparing" mat-raised-button (click)="prepareMailing()" color="blue"
                              [disabled]="newsletter == null || newsletter?.id == null || isPreparing || newsletter?.isPreparing || (newsletter?.isSent ?? false)">
                        <span *ngIf="!newsletter.isPrepared">Prepare recipients</span>
                        <span *ngIf="newsletter.isPrepared">Re-calc recipients</span>
                      </button>

                      <button *ngIf="!(newsletter.isSending || newsletter.isSent) && newsletter.isActive"
                              mat-raised-button color="accent" (click)="unapprove()">Cancel approval</button>

                      <button *ngIf="!(newsletter.isSending || newsletter.isSent) && !newsletter.isActive"
                              [disabled]="isNaN(nlid) || newsletter == null || newsletter?.id == null || isPreparing || newsletter?.isPreparing"
                              mat-raised-button color="primary" (click)="approve()">Approve for sending</button>

                      <span style="color: #f3a436;" *ngIf="newsletter.isSending">
        Sending... {{ newsletter?.sentCount }}/{{ (newsletter?.queuedCount + newsletter?.sentCount) }}
      </span>

                      <span style="color: darkolivegreen;" *ngIf="newsletter.isSent">
        Sent - {{ newsletter?.sentCount }}
      </span>

                      <!-- Emergency Stop -->
                      <button *ngIf="newsletter && newsletter.isSending" (click)="emergencyStop()" mat-raised-button color="warn">
                        Emergency stop
                      </button>
                    </div>
                  </div>
                </div>


                <div style="margin-top: 10px;" *ngIf="newsletter">
                  <mat-progress-bar *ngIf="isLoading && !newsletter.isSending" mode="indeterminate"></mat-progress-bar>
                  <mat-progress-bar *ngIf="!isLoading && !newsletter.isSending" mode="determinate" [value]="0"></mat-progress-bar>
                  <mat-progress-bar *ngIf="newsletter.isSending" mode="determinate" [value]="newsletter.sentCount / ((newsletter.sentCount + newsletter.queuedCount) != 0 ? (newsletter.sentCount + newsletter.queuedCount) : 1) * 100"></mat-progress-bar>
                </div>
                <ng-container *ngIf="!newsletter && isLoading">
                  <mat-progress-bar mode="determinate" [value]="0"></mat-progress-bar>
                </ng-container>


                <form *ngIf="templateForm" [formGroup]="templateForm" (ngSubmit)="onSubmit(templateForm)">

                  <div fxLayout="row" fxLayoutGap="10px">
                    <div fxFlex="30">


                      <mat-card-title>
                        <h6>Settings</h6>
                      </mat-card-title>

                      <div style="width: 100%;">
                        <mat-form-field class="full-width">
                          <input matInput placeholder="Name" formControlName="name" >
                        </mat-form-field>
                      </div>

                      <div style="width: 100%;">
                        <div fxFlex="50">
                          <app-date-edit formControlName="sendDate" placeholder="Send Date" required></app-date-edit>
                        </div>
                        <div fxFlex="25">
                          <mat-form-field class="full-width">
                            <input matInput type="number" placeholder="hh" formControlName="sendDateHh" required>
                          </mat-form-field>
                        </div>
                        <div fxFlex="25">
                          <mat-form-field class="full-width">
                            <input matInput placeholder="mm"  formControlName="sendDateMm" required>
                          </mat-form-field>
                        </div>
                      </div>

                      <div style="width: 100%;">
                        <ng-container *ngIf="newsletter?.type == newsletterType.Email">
                          <mat-form-field class="full-width">
                            <input matInput placeholder="Subject" formControlName="subject">
                          </mat-form-field>
                        </ng-container>


                      </div>


                      <mat-card-title>
                        <h6 *ngIf="newsletter?.recipientsCount == null || newsletter?.isSent">Filter</h6>
                        <h6 *ngIf="newsletter?.recipientsCount != null && !newsletter.isPrepared && !newsletter.isSent && !newsletter.isRecipientsManually">Filter ~ approx. <span class="recipients-badge">{{ newsletter?.recipientsCount }}</span> recipients</h6>
                        <h6 *ngIf="newsletter?.recipientsCount != null && newsletter.isPrepared && !newsletter.isSent && !newsletter.isRecipientsManually">Filter <span class="recipients-badge">{{ newsletter?.recipientsCount }}</span> recipients</h6>

                        <h6 *ngIf="newsletter?.recipientsCount != null && !newsletter.isSent && newsletter.isRecipientsManually" style="color: dodgerblue">Manual Filter - {{ newsletter?.recipientsCount }} recipients</h6>
                      </mat-card-title>


                      <div *ngIf="newsletter && (newsletter.isSent || newsletter.isActive)">
                        <h5>Selected Filters</h5>
                        <ul class="filterUl">
                          <li *ngIf="templateForm.value.filterOrderLanguagesAsList?.length">
                            <strong>Order Language:</strong> {{ templateForm.value.filterOrderLanguagesAsList.join(', ') }}
                          </li>
                          <li *ngIf="templateForm.value.filterPlatformsAsList?.length">
                            <strong>Platform:</strong> {{ templateForm.value.filterPlatformsAsList.join(', ') }}
                          </li>
                          <li *ngIf="templateForm.value.getFilterCompanyIdsAsList?.length">
                            <strong>Brand:</strong> {{ getCompanyNames(templateForm.value.getFilterCompanyIdsAsList).join(', ') }}
                          </li>
                          <li *ngIf="templateForm.value.getFilterNotInNewsletterIdsAsList?.length">
                            <strong>NOT in previous Newsletter:</strong> {{ getNewsletterNames(templateForm.value.getFilterNotInNewsletterIdsAsList).join(', ') }}
                          </li>
                          <li *ngIf="templateForm.value.getFilterInNewsletterIdsAsList?.length">
                            <strong>IN previous Newsletter:</strong> {{ getNewsletterNames(templateForm.value.getFilterInNewsletterIdsAsList).join(', ') }}
                          </li>
                          <li *ngIf="templateForm.value.filterCustomerIds">
                            <strong>Customer IDs:</strong> {{ templateForm.value.filterCustomerIds }}
                          </li>
                          <li *ngIf="templateForm.value.getFilterProductIdsAsList?.length">
                            <strong>Has Product:</strong> {{ getProductNames(templateForm.value.getFilterProductIdsAsList).join(', ') }}
                          </li>
                          <li *ngIf="templateForm.value.getFilterNotProductIdsAsList?.length">
                            <strong>Does NOT have Product:</strong> {{ getProductNames(templateForm.value.getFilterNotProductIdsAsList).join(', ') }}
                          </li>
                          <li *ngIf="templateForm.value.getFilterCardStatusIdsAsList?.length">
                            <strong>Card status:</strong> {{ getCardStatusNames(templateForm.value.getFilterCardStatusIdsAsList).join(', ') }}
                          </li>
                          <li *ngIf="templateForm.value.getFilterCustomerIdentLevelsAsList?.length">
                            <strong>Customer Ident Level:</strong> {{ templateForm.value.getFilterCustomerIdentLevelsAsList.join(', ') }}
                          </li>
                          <li *ngIf="templateForm.value.filterAppDownload !== null">
                            <strong>App downloaded:</strong> {{ templateForm.value.filterAppDownload ? 'yes' : 'no' }}
                          </li>
                          <li *ngIf="templateForm.value.filterSepa !== null">
                            <strong>Sepa loaded:</strong> {{ templateForm.value.filterSepa ? 'yes' : 'no' }}
                          </li>
                          <li *ngIf="templateForm.value.filterSofort !== null">
                            <strong>Sofort loaded:</strong> {{ templateForm.value.filterSofort ? 'yes' : 'no' }}
                          </li>
                          <li *ngIf="templateForm.value.filterBtl !== null">
                            <strong>BTL loaded:</strong> {{ templateForm.value.filterBtl ? 'yes' : 'no' }}
                          </li>
                          <li *ngIf="templateForm.value.filterAddressConfirmed !== null">
                            <strong>Address Confirmed:</strong> {{ templateForm.value.filterAddressConfirmed ? 'yes' : 'no' }}
                          </li>
                          <li *ngIf="templateForm.value.filterReOrderPending !== null">
                            <strong>Pending Re-Order:</strong> {{ templateForm.value.filterReOrderPending ? 'yes' : 'no' }}
                          </li>
                          <li *ngIf="templateForm.value.filterReOrderDelayReason">
                            <strong>Re-Order Reason:</strong> {{ templateForm.value.filterReOrderDelayReason }}
                          </li>
                          <li *ngIf="templateForm.value.filterCreateDateFrom">
                            <strong>Card creation date from:</strong> {{ templateForm.value.filterCreateDateFrom | date:'yyyy-MM-dd' }}
                          </li>
                          <li *ngIf="templateForm.value.filterCreateDateTo">
                            <strong>Card creation date to:</strong> {{ templateForm.value.filterCreateDateTo | date:'yyyy-MM-dd' }}
                          </li>
                          <li *ngIf="templateForm.value.filterOrderDateFrom">
                            <strong>Order date from:</strong> {{ templateForm.value.filterOrderDateFrom | date:'yyyy-MM-dd' }}
                          </li>
                          <li *ngIf="templateForm.value.filterOrderDateTo">
                            <strong>Order date to:</strong> {{ templateForm.value.filterOrderDateTo | date:'yyyy-MM-dd' }}
                          </li>
                          <li *ngIf="templateForm.value.filterOrderCreateDateFrom">
                            <strong>Order creation date from:</strong> {{ templateForm.value.filterOrderCreateDateFrom | date:'yyyy-MM-dd' }}
                          </li>
                          <li *ngIf="templateForm.value.filterOrderCreateDateTo">
                            <strong>Order creation date to:</strong> {{ templateForm.value.filterOrderCreateDateTo | date:'yyyy-MM-dd' }}
                          </li>
                        </ul>
                      </div>


                      <ng-container *ngIf="newsletter && !newsletter.isActive && !newsletter.isRecipientsManually">

                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <mat-form-field>
                              <mat-label>Order Language</mat-label>
                              <mat-select formControlName="filterOrderLanguagesAsList" multiple>
                                <mat-option *ngFor="let language of orderLanguages" [value]="language">
                                  {{ language }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>

                        <div style="width: 100%">
                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <mat-form-field>
                              <mat-label>Platform</mat-label>
                              <mat-select formControlName="filterPlatformsAsList" multiple>
                                <mat-option [value]="0">Unknown</mat-option>
                                <mat-option [value]="1">iOS</mat-option>
                                <mat-option [value]="2">Android</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>


                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <mat-form-field>
                              <mat-label>Brand</mat-label>
                              <mat-select formControlName="getFilterCompanyIdsAsList" multiple>
                                <!--<mat-select-trigger>
                                  <span> {{ getSelectesCompanyNames().join(' OR ') }}</span>
                                </mat-select-trigger>-->
                                <mat-option *ngFor="let company of companies"
                                            [value]="company.id">
                                  {{company.name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>

                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <mat-form-field>
                              <mat-label>NOT in previous Newsletter</mat-label>
                              <mat-select formControlName="getFilterNotInNewsletterIdsAsList" multiple>
                                <!--<mat-select-trigger>
                                  <span> {{ getSelectesCompanyNames().join(' OR ') }}</span>
                                </mat-select-trigger>-->
                                <mat-option *ngFor="let nl of otherNewsletters; trackBy: trackOtherNewslettersByFn" [value]="nl.id">
                                  {{ nl.sendDate | date : 'yyyy-MM-dd HH:mm'  }} {{ nl.name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>

                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <mat-form-field>
                              <mat-label>IN previous Newsletter - use for follow-ups</mat-label>
                              <mat-select formControlName="getFilterInNewsletterIdsAsList" multiple>
                                <!--<mat-select-trigger>
                                  <span> {{ getSelectesCompanyNames().join(' OR ') }}</span>
                                </mat-select-trigger>-->
                                <mat-option *ngFor="let nl of otherNewsletters; trackBy: trackOtherNewslettersByFn" [value]="nl.id">
                                  {{ nl.sendDate | date : 'yyyy-MM-dd HH:mm'  }} {{ nl.name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>

                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <mat-form-field>
                              <mat-label>Only specific customers</mat-label>

                                <input matInput placeholder="Customer IDs, comma separated, no spaces" formControlName="filterCustomerIds">


                            </mat-form-field>
                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>

                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <mat-form-field>
                              <mat-label>has Product</mat-label>
                              <mat-select formControlName="getFilterProductIdsAsList" multiple>
                                <!--<mat-select-trigger>
                                  <span> {{ getSelectesCompanyNames().join(' OR ') }}</span>
                                </mat-select-trigger>-->
                                <mat-option *ngFor="let product of products"
                                            [value]="product.id">
                                  <ng-container *ngIf="!product.active">❌ </ng-container> {{ product.shortName }} - {{product.internalName }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>
                        <div style="width: 100%">
                        <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                          <mat-form-field>
                            <mat-label>does NOT have Product</mat-label>
                            <mat-select formControlName="getFilterNotProductIdsAsList" multiple>
                              <!--<mat-select-trigger>
                                <span> {{ getSelectesCompanyNames().join(' OR ') }}</span>
                              </mat-select-trigger>-->
                              <mat-option *ngFor="let product of products"
                                          [value]="product.id">
                                <ng-container *ngIf="!product.active">❌ </ng-container> {{ product.shortName }} - {{product.internalName }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div style="display: inline-block; width: 19%; text-align: right;">
                          <small style="color: grey;">AND</small>
                        </div>
                        </div>

                      <div style="width: 100%">
                        <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                          <mat-form-field>
                          <mat-label>Card status</mat-label>
                          <mat-select formControlName="getFilterCardStatusIdsAsList" multiple>
                            <mat-option *ngFor="let status of cardStatuses"
                                        [value]="status.id">
                              {{status.name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        </div>
                        <div style="display: inline-block; width: 19%; text-align: right;">
                          <small style="color: grey;">AND</small>
                        </div>
                      </div>


                        <div style="width: 100%">
                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <mat-form-field>
                            <mat-label>Customer Ident Level</mat-label>
                            <mat-select formControlName="getFilterCustomerIdentLevelsAsList" multiple>
                              <mat-option [value]="1">SDD</mat-option>
                              <mat-option [value]="2">FDD</mat-option>
                              <mat-option [value]="3">EDD</mat-option>
                            </mat-select>
                          </mat-form-field>
                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>


                        <!--<div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <mat-form-field>
                              <mat-label>WebID status</mat-label>
                              <mat-select formControlName="getFilterWebIdStatusIdsAsList" multiple>
                                <mat-option *ngFor="let status of webIdStatis"
                                            [value]="status.id">
                                  {{status.name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>-->

                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <label style="width: 50%; display: inline-block">App downloaded</label> &nbsp;&nbsp;&nbsp;&nbsp;
                            <app-tri-state-checkbox formControlName="filterAppDownload">
                              <label *ngIf="templateForm != null && templateForm.controls['filterAppDownload'].value == true">&nbsp;&nbsp;yes</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterAppDownload'].value == false">&nbsp;&nbsp;no</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterAppDownload'].value == null">&nbsp;&nbsp;yes and no</label>
                            </app-tri-state-checkbox>

                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>

                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <label style="width: 50%; display: inline-block">Sepa loaded</label> &nbsp;&nbsp;&nbsp;&nbsp;
                            <app-tri-state-checkbox formControlName="filterSepa">
                              <label *ngIf="templateForm != null && templateForm.controls['filterSepa'].value == true">&nbsp;&nbsp;yes</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterSepa'].value == false">&nbsp;&nbsp;no</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterSepa'].value == null">&nbsp;&nbsp;yes and no</label>
                            </app-tri-state-checkbox>

                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>

                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <label style="width: 50%; display: inline-block">Sofort loaded</label> &nbsp;&nbsp;&nbsp;&nbsp;
                            <app-tri-state-checkbox formControlName="filterSofort">
                              <label *ngIf="templateForm != null && templateForm.controls['filterSofort'].value == true">&nbsp;&nbsp;yes</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterSofort'].value == false">&nbsp;&nbsp;no</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterSofort'].value == null">&nbsp;&nbsp;yes and no</label>
                            </app-tri-state-checkbox>

                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>

                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <label style="width: 50%; display: inline-block">BTL loaded</label> &nbsp;&nbsp;&nbsp;&nbsp;
                            <app-tri-state-checkbox formControlName="filterBtl">
                              <label *ngIf="templateForm != null && templateForm.controls['filterBtl'].value == true">&nbsp;&nbsp;yes</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterBtl'].value == false">&nbsp;&nbsp;no</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterBtl'].value == null">&nbsp;&nbsp;yes and no</label>
                            </app-tri-state-checkbox>

                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>

                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <label style="width: 50%; display: inline-block">Address Confirmed (POA)</label> &nbsp;&nbsp;&nbsp;&nbsp;
                            <app-tri-state-checkbox formControlName="filterAddressConfirmed">
                              <label *ngIf="templateForm != null && templateForm.controls['filterAddressConfirmed'].value == true">&nbsp;&nbsp;yes</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterAddressConfirmed'].value == false">&nbsp;&nbsp;no</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterAddressConfirmed'].value == null">&nbsp;&nbsp;yes and no</label>
                            </app-tri-state-checkbox>

                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>


                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <label style="width: 50%; display: inline-block">Pending Re-Order</label> &nbsp;&nbsp;&nbsp;&nbsp;
                            <app-tri-state-checkbox formControlName="filterReOrderPending">
                              <label *ngIf="templateForm != null && templateForm.controls['filterReOrderPending'].value == true">&nbsp;&nbsp;yes</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterReOrderPending'].value == false">&nbsp;&nbsp;no</label>
                              <label *ngIf="templateForm != null && templateForm.controls['filterReOrderPending'].value == null">&nbsp;&nbsp;yes and no</label>
                            </app-tri-state-checkbox>

                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>


                        <div style="width: 100%">

                          <div style="display: inline-block; width: 80%; margin-top: 5px; margin-bottom: 5px;">
                            <mat-form-field>
                              <mat-label>Pending Re-Order - Reason</mat-label>
                              <mat-select formControlName="filterReOrderDelayReason">
                                <mat-option [value]="null">- Any- </mat-option>
                                <mat-option [value]="reorderDelayReason.None">None</mat-option>
                                <mat-option [value]="reorderDelayReason.NoIdent">No Ident</mat-option>
                                <mat-option [value]="reorderDelayReason.MultipleReorders">Multiple re-orders</mat-option>
                                <mat-option [value]="reorderDelayReason.OverdueInvoice">Overdue invoice</mat-option>
                                <mat-option [value]="reorderDelayReason.AddressUnconfirmed">Address unconfirmed</mat-option>

                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div style="display: inline-block; width: 19%; text-align: right;">
                            <small style="color: grey;">AND</small>
                          </div>
                        </div>


                      <div style="width: 100%;">
                        <div fxFlex="50">
                          <app-date-edit formControlName="filterCreateDateFrom" placeholder="Card creation date from"></app-date-edit>
                        </div>
                        <div fxFlex="50">
                          <app-date-edit formControlName="filterCreateDateTo" placeholder="Card creation date to"></app-date-edit>
                        </div>
                      </div>
                      <div style="width: 100%; padding-left: 10px; margin-bottom: 8px;">
                        <small style="color: grey;">AND</small>
                      </div>
                      <div style="width: 100%;">
                        <div fxFlex="50">
                          <app-date-edit formControlName="filterOrderDateFrom" placeholder="Order date from"></app-date-edit>
                        </div>
                        <div fxFlex="50">
                          <app-date-edit formControlName="filterOrderDateTo" placeholder="Order date to"></app-date-edit>
                        </div>
                      </div>

                      <div style="width: 100%; padding-left: 10px; margin-bottom: 8px;">
                        <small style="color: grey;">AND</small>
                      </div>
                      <div style="width: 100%;">
                        <div fxFlex="50">
                          <app-date-edit formControlName="filterOrderCreateDateFrom" placeholder="Order creation date from"></app-date-edit>
                        </div>
                        <div fxFlex="50">
                          <app-date-edit formControlName="filterOrderCreateDateTo" placeholder="Order creation date to"></app-date-edit>
                        </div>
                      </div>

                      <mat-card-actions align="end">
                        <a mat-raised-button color="warn" routerLink="/send-info">Cancel</a>
                        <button mat-raised-button color="primary"
                                >Save</button>
                      </mat-card-actions>
                      </ng-container>




                    </div>



                    <div fxFlex="70">

                      <div>
                        <mat-card-title>
                          <h6 *ngIf="details?.length > 0"><span class="recipients-badge">{{details?.length}}</span> recipients</h6>
                          <h6 *ngIf="details?.length == 0"><span class="recipients-badge">1</span> recipient</h6>
                          <h6 *ngIf="details?.length == null">Recipients</h6>
                        </mat-card-title>

                        <div [hidden]="!isDetailsLoading">
                          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        </div>
                        <div class="">
                          <table style="width: 100%;" mat-table [dataSource]="dataSource">

                            <!-- Position Column -->
                            <ng-container matColumnDef="email">
                              <th mat-header-cell *matHeaderCellDef>
                                <ng-container *ngIf="newsletter?.type == NewsletterType.Email">E-Mail</ng-container>
                                <ng-container *ngIf="newsletter?.type == NewsletterType.Sms">Phone</ng-container>
                                <ng-container *ngIf="newsletter?.type == NewsletterType.Push">Device</ng-container>

                              </th>
                              <td mat-cell *matCellDef="let element"> {{innerEllipsis(element.email)}} </td>
                            </ng-container>

                            <ng-container matColumnDef="firstName">
                              <th mat-header-cell *matHeaderCellDef> Firstname</th>
                              <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
                            </ng-container>

                            <ng-container matColumnDef="lastName">
                              <th mat-header-cell *matHeaderCellDef> Lastname</th>
                              <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
                            </ng-container>


                            <ng-container matColumnDef="mandrillStatusName">
                              <th mat-header-cell *matHeaderCellDef> Status</th>
                              <td mat-cell *matCellDef="let element"> {{element.mandrillStatusName}} </td>
                            </ng-container>


                            <ng-container matColumnDef="mandrillOpens">
                              <th mat-header-cell *matHeaderCellDef> Opens</th>
                              <td mat-cell *matCellDef="let element"> {{element.mandrillOpens}} </td>
                            </ng-container>


                            <ng-container matColumnDef="mandrillClicks">
                              <th mat-header-cell *matHeaderCellDef>Clicks</th>
                              <td mat-cell *matCellDef="let element"> {{element.mandrillClicks}} </td>
                            </ng-container>


                            <ng-container matColumnDef="mandrillDiag">
                              <th mat-header-cell *matHeaderCellDef> </th>
                              <td mat-cell *matCellDef="let element"> {{element.mandrillDiag}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                          </table>
                          <mat-paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>
                        </div>


                        <!--
                        <table class="list-table">
                          <thead>
                          <th style="text-align: left;">E-Mail</th>
                          <th style="text-align: left;">Firstname</th>
                          <th style="text-align: left;">Lastname</th>
                          <th style="text-align: left;">Status</th>
                          <th style="text-align: left;">Opens</th>
                          <th style="text-align: left;">Clicks</th>
                          <th style="text-align: left;">Diag</th>
                          </thead>
                          <tr *ngFor="let d of details">
                            <td style="text-align: left;">{{ d.email }}</td>
                            <td style="text-align: left;">{{ d.firstName }}</td>
                            <td style="text-align: left;">{{ d.lastName }}</td>
                            <td style="text-align: left;">{{ d.mandrillStatusName }}</td>
                            <td style="text-align: left;">{{ d.mandrillOpens }}</td>
                            <td style="text-align: left;">{{ d.mandrillClicks }}</td>
                            <td style="text-align: left;">{{ d.mandrillDiag }}</td>
                          </tr>
                        </table>
                        -->
                      </div>
                    </div>
                  </div>





                  <div [hidden]="newsletter == null || newsletter.id == null" style="margin-top: 20px;">
                    <div style="width: 30%">
                      <form *ngIf="testEmailForm" [formGroup]="testEmailForm" (ngSubmit)="sendTest()">
                        <mat-form-field class="full-width">
                          <input matInput [placeholder]="newsletter.type == NewsletterType.Email || newsletter.type == NewsletterType.Push ? 'Test E-Mail address' : newsletter.type == NewsletterType.Sms ? 'Phone number' : 'UNKNOWN'" formControlName="email">
                        </mat-form-field>
                        <mat-card-actions align="end">
                          <button mat-raised-button color="primary" [disabled]="newsletter == null || newsletter?.id == null"
                                  >Send Test</button>
                        </mat-card-actions>

                      </form>

                    </div>

                    <br /><br />

                    <ng-container *ngIf="newsletter?.type == newsletterType.Email">
                      <app-grapesjs-editor [commands]="commands" [mjml]="templateForm.value.mjml" (onSaved)="saveFromEditor($event)" #sharedgjs></app-grapesjs-editor>
                    </ng-container>

                    <ng-container *ngIf="newsletter?.type == newsletterType.Sms">


                      <div class="template-var-group">
                        <button *ngFor="let cmd of smsCommands" mat-raised-button class="template-var-item" color="primary" type="button"
                                (click)="addText(cmd.name)">{{cmd.title}}</button>
                      </div>

                      <mat-form-field>
                        <textarea rows="6" matInput placeholder="Message" [formControlName]="'subject'" #textareamessage ></textarea>
                      </mat-form-field>

                      <span *ngIf="templateForm?.controls['subject']?.value?.length > 160" style="color: red;">
                            ~ {{ templateForm?.controls['subject']?.value?.length }}
                          </span>
                      <span *ngIf="templateForm?.controls['subject']?.value?.length <= 160" style="color: green;">
                            ~ {{ templateForm?.controls['subject']?.value?.length }}
                          </span>
                      <span>
                            &nbsp;/&nbsp; 160 &nbsp;&nbsp;&nbsp;&nbsp;
                          </span>
                      <div *ngIf="templateForm?.controls['subject']?.value?.includes('*|')" style="margin-top: 15px;">
                        <mat-icon style="color: red;">info</mat-icon><span class="aligned-with-icon" style="color:red;">The length of the message cannot be calculated correctly because placeholders are used</span>
                      </div>

                      <!--<mat-form-field class="full-width">
                          <input matInput placeholder="Text" formControlName="subject" required>
                          <div style="font-size: 8px; color: red;">Max 160 characters!</div>
                      </mat-form-field>-->
                    </ng-container>

                    <ng-container *ngIf="newsletter?.type == newsletterType.Push">

                      <div class="template-var-group">
                        <button *ngFor="let cmd of pushCommands" mat-raised-button class="template-var-item" color="primary" type="button"
                                (click)="insert(cmd.name)">{{cmd.title}}</button>
                      </div>


                      <br />

                      <app-emoji-list (emojiSelected)="onEmojiSelected($event)"></app-emoji-list>

                      <br /><br />

                      <div style="background-color: lightblue; padding: 20px; border-radius: 15px;">

                        <div><i>In the notification area of the device</i></div>
                        <br />

                        <div><b>Notification Title</b></div>
                        <div>
                          <small>Displayed in the notification area of the device</small>
                        </div>
                        <mat-form-field class="full-width" >
                          <input (focusin)="onFocus($event)" matInput placeholder="Enter notification title" formControlName="title" />
                        </mat-form-field>

                        <div><b>Notification Text</b></div>
                        <div>
                          <small>Displayed in the notification area of the device</small>
                        </div>
                        <mat-form-field class="full-width">
                          <input (focusin)="onFocus($event)" matInput placeholder="Enter notification text" formControlName="mjml" />
                        </mat-form-field>


                      </div>

                      <br /><br />

                      <div style="background-color: lightgray; padding: 20px; border-radius: 15px;">
                        <div><i>In-App after the user taps the notification</i></div>
                        <br />

                        <div><b>Body Title</b></div>
                        <div>
                          <small>Displayed in-app when the user taps the notification</small>
                        </div>
                        <mat-form-field class="full-width">
                          <input (focusin)="onFocus($event)" matInput placeholder="Enter body title" formControlName="subject" />
                        </mat-form-field>


                        <div><b>Body Text</b></div>
                        <div>
                          <small>Displayed in-app when the user taps the notification</small>
                        </div>
                        <textarea (focusin)="onFocus($event)" cols="50" rows="20" placeholder="Enter message template" formControlName="bodyHtml"></textarea>


                        <div><b>Action and Action Label</b></div>

                        <div>
                          <small>If an action is selected, the label of the respective button</small>
                        </div>
                        <mat-form-field>
                          <mat-select placeholder="Action" formControlName="action">
                            <mat-option [value]="">(none - no button)</mat-option>
                            <mat-option [value]="'add_card'">Card upgrades</mat-option>
                            <mat-option [value]="'ident'">Ident</mat-option>
                            <mat-option [value]="'top_up'">Top up</mat-option>
                            <mat-option [value]="'refer_friends'">Refer friends</mat-option>
                            <mat-option [value]="'convert_physical'">Convert to physical</mat-option>

                            <mat-option [value]="'dynaview'">Dynamic view</mat-option>


                          </mat-select>
                        </mat-form-field>


                        <br />

                        <div>
                          <small>If the selected action needs a parameter, specify here</small>
                        </div>
                        <mat-form-field class="full-width">
                          <input (focusin)="onFocus($event)" type="text" matInput placeholder="Action parameter" formControlName="actionParameter" />
                        </mat-form-field>

                        <br />

                        <div>
                          <small>If an action is selected, the label of the respective button</small>
                        </div>
                        <mat-form-field class="full-width">
                          <input (focusin)="onFocus($event)" matInput placeholder="Enter action label" formControlName="actionLabel" />
                        </mat-form-field>


                      </div>

                    </ng-container>


                  </div>
                </form>




                <mat-card-title>
                  <h6>Preview</h6>
                </mat-card-title>
                <iframe width="100%" height="500" #iframeD></iframe>


              </mat-card-content>
              <mat-card-actions align="end">
                <a mat-raised-button color="warn" routerLink="/send-info">Cancel</a>
                  <button mat-raised-button color="primary" [disabled]="!templateForm?.valid"
                          (click)="save()">Save</button>
              </mat-card-actions>
          </mat-card>

        </div>
  </div>


</div>
